export const CURRICULUM_UPDATE_CURRICULUM_LIST = 'CURRICULUM_UPDATE_CURRICULUM_LIST'
export const CURRICULUM_UPDATE_CURRICULUM_LIST_METHOD = 'CURRICULUM_UPDATE_CURRICULUM_LIST_METHOD'
export const CURRICULUM_CHANGE_CURRICULUM = 'CURRICULUM_CHANGE_CURRICULUM'
export const CURRICULUM_UPDATE_LEVELS_LIST = 'CURRICULUM_UPDATE_LEVELS_LIST'
export const CURRICULUM_UPDATE_LEVELS_LIST_METHOD = 'CURRICULUM_UPDATE_LEVELS_LIST_METHOD'
export const CURRICULUM_UPDATE_MARKING_LIST = 'CURRICULUM_UPDATE_MARKING_LIST'
export const CURRICULUM_UPDATE_MARKING_LIST_METHOD = 'CURRICULUM_UPDATE_MARKING_LIST_METHOD'
export const CURRICULUM_UPDATE_LC_ELEMENTS_LIST = 'CURRICULUM_UPDATE_LC_ELEMENTS_LIST'
export const CURRICULUM_UPDATE_LC_ELEMENTS_LIST_METHOD = 'CURRICULUM_UPDATE_LC_ELEMENTS_LIST_METHOD'
export const CURRICULUM_UPDATE_ELEMENTS_LIST = 'CURRICULUM_UPDATE_ELEMENTS_LIST'
export const CURRICULUM_UPDATE_ELEMENTS_LIST_METHOD = 'CURRICULUM_UPDATE_ELEMENTS_LIST_METHOD'
export const CURRICULUM_UPDATE_ELEMENTS_STRUCTURE = 'CURRICULUM_UPDATE_ELEMENTS_STRUCTURE'
export const CURRICULUM_UPDATE_SEMESTER_REPORT = 'CURRICULUM_UPDATE_SEMESTER_REPORT'
export const CURRICULUM_UPDATE_SEMESTER_REPORT_LIST = 'CURRICULUM_UPDATE_SEMESTER_REPORT_LIST'
export const CURRICULUM_UPDATE_SEMESTER_REPORT_LIST_METHOD = 'CURRICULUM_UPDATE_SEMESTER_REPORT_LIST_METHOD'

// Curriculum
export const updateCurriculumsList = (data = []) => ({
  type: CURRICULUM_UPDATE_CURRICULUM_LIST,
  payload: { data }
});
export const updateCurriculumsListMethod = (method = 'POST', data) => ({
  type: CURRICULUM_UPDATE_CURRICULUM_LIST_METHOD,
  payload: { method, data }
});
export const changedCurriculum = () => ({
  type: CURRICULUM_CHANGE_CURRICULUM
});

// Levels
export const updateLevelsList = (data = []) => ({
  type: CURRICULUM_UPDATE_LEVELS_LIST,
  payload: { data }
});
export const updateLevelsListMethod = (method = 'POST', data) => ({
  type: CURRICULUM_UPDATE_LEVELS_LIST_METHOD,
  payload: { method, data }
})

// Marking
export const updateMarkingList = (data = []) => ({
  type: CURRICULUM_UPDATE_MARKING_LIST,
  payload: { data }
})
export const updateMarkingListMethod = (method = 'POST', data) => ({
  type: CURRICULUM_UPDATE_MARKING_LIST_METHOD,
  payload: { method, data }
})

// Element
export const updateElementsList = (data = []) => ({
  type: CURRICULUM_UPDATE_ELEMENTS_LIST,
  payload: { data }
})
export const updateElementsListMethod = (method = 'POST', data) => ({
  type: CURRICULUM_UPDATE_ELEMENTS_LIST_METHOD,
  payload: { method, data }
})

// Element Structure
export const updateElementsStructure = (data = {}) => ({
  type: CURRICULUM_UPDATE_ELEMENTS_STRUCTURE,
  payload: { data }
})

// LC Element
export const updateLcElementsList = (data = []) => ({
  type: CURRICULUM_UPDATE_LC_ELEMENTS_LIST,
  payload: { data }
})
export const updateLcElementsListMethod = (method = 'POST', data) => ({
  type: CURRICULUM_UPDATE_LC_ELEMENTS_LIST_METHOD,
  payload: { method, data }
})

// Semester report
export const updateSemesterReportData = (data = []) => ({
  type: CURRICULUM_UPDATE_SEMESTER_REPORT,
  payload: { data }
})
export const updateSemesterReportElementList = (element = 'assessment', data = []) => ({
  type: CURRICULUM_UPDATE_SEMESTER_REPORT_LIST,
  payload: { element, data }
})
export const updateSemesterReportElementListMethod = (element = 'assessment', method = 'POST', data) => ({
  type: CURRICULUM_UPDATE_SEMESTER_REPORT_LIST_METHOD,
  payload: { element, method, data }
})
